<template lang="pug">
div.container
  div.body
    div
      div.logo
        img( src="@/assets/kiddiecoinLogo.svg")
      div.header
        span.text-23-b Вход в систему
    
      div.data-phone
        castom-text-field( v-model="phoneNumber" :height="58" placeholder="Номер телефона" v-mask="'+7 (###) ###-##-##'" )
        castom-text-field( v-model="phonePassword" :height="58" :type="returnTypePassword" placeholder="Пароль" )
        div.img-eye(@click="lookPassword = !lookPassword")
          img(v-if="lookPassword" src="@/assets/mdi-imgs/eye.svg")
          img(v-if="!lookPassword" src="@/assets/mdi-imgs/eye-off.svg")
    
    .authorization-buttons
      .sign-in
        .auth-btn
          button(label='Войти' :disable='!checkData' @click="auth()") Войти
        .empty-div

</template>

<script>
import {authService} from '@/_services/auth.service'
import { mapActions } from 'vuex';
export default{
  name:"UserAuthorization",
  components: {
  },

  data(){
    return {
      phoneNumber: "",
      phonePassword: "",
      animation: false,
      lookPassword: false
    }
  },

  computed: {
    checkData() {
      return this.phoneNumber.length == 10 && this.phonePassword
    },

    returnTypePassword() {
      return this.lookPassword ? 'str' : 'password'
    }
  },

  methods: {
    ...mapActions('user', ["loadUserInfo"]),
    auth() {
      let login = this.phoneNumber.replace(/\D/g, '')
      let password = this.phonePassword
      let mode = 1
      authService.kiddiePath()
      authService.auth(login, password, mode).then(data => {
        if(data.data.status != "ok") {
          window.alert(data.data.error_list[0].processing_error_msg)
          return
        }
        this.loadUserInfo().then(() => {
          this.$router.push('/start')
        })
        
      })

    },
  }
  
}
</script>

<style scoped>
.container{
  width: 100%;
  height: 100%;
}
.body{
  width: auto;
  height: 100%;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 40px 16px 0px 16px;
}
.logo{
  margin: 0px 0px 10px 0px;
}
.header{
  text-align: center;
  margin: 30px 0;
}
.data-phone{
  display: flex;
  flex-direction: column;
}
.input{
  margin: 0px 0px 10px 0px;
}
.password-recovery{
  margin: 10px 0px 10px 0px;
}
.password-recovery-message{
  float: right;
  color: #3374C8;
  margin: 0px 10px 0px 0px;
}
.sign-in{
  display: flex;
  align-items: center;
  justify-content: end;
}
.sign-in div {
  display: flex;
  justify-content: center;
  width: 33.33%;
}
.sign-up{
  align-self: flex-end;
  width: 100%;
  text-align: center;
  margin: 30px 0px 50px 0px;
}
.sign-up-button{
  color: #007EFF;
}
.img-eye {
  position: absolute;
  z-index: 998;
  width: 24px;
  right: 40px;
  margin-top: 5px;
  padding-top: 83px;
}
.auth-btn {
  box-shadow: 0px 4px 6px 0px #0000001A;
  box-shadow: 0px 2px 4px 0px #0000001A;
  background: linear-gradient(90deg, #FF9900 0%, #F6514C 100%);
  width: 120px;
  height: 58px;
  border-radius: 12px;
  color: white;
}
.authorization-buttons {
  margin-bottom: 77px;
}
</style>